import { useEffect } from "react"
import { Col, Form, FormFeedback, Input } from "reactstrap"

import "react-image-lightbox/style.css";

import * as Yup from "yup";
import { useFormik } from "formik";

import { useSafetyCreateMutation } from "store";
import Flatpickr from "react-flatpickr";
import { numberWithCommas } from "../../helpers/globalHelper";


const Create = (props: any) => {
  const [safetyCreate, safetyCreateResult] = useSafetyCreateMutation();

  useEffect(() => {
    console.log(props);

  }, [props?.table_name, props?.id])

  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
    },
    validationSchema: Yup.object({
      funder_description: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      description: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      company_description: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      total_cost: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      safeted_date: Yup.date().typeError("Он сар өдөр оруулна уу").required("Утга оруулна уу !"),
    }),
    onSubmit: (values: any) => {
      const newStaffList = {
        table_name: props?.table_name,
        connection_id: props?.id,
        funder_description: values["funder_description"],
        company_description: values["company_description"],
        description: values["description"],
        total_cost: values["total_cost"],
        safeted_date: values["safeted_date"],
      };
      safetyCreate(newStaffList);
      validation.resetForm();
    },
  });

  return (
    <>
      <Col xl={5}>
        <h5 className="fw-semibold text-center">Санхүүжүүлэлт</h5>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <div className="table-responsive">
            <table className="table">
              <tbody>
                <tr>
                  <th scope="col">Санхүүжүүлэгч:</th>
                  <td className="fs-6">
                    <Input
                      name="funder_description"
                      type="text"
                      validate={{
                        required: { value: true },
                      }}
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.funder_description || ""}
                      invalid={
                        validation.touched.funder_description && validation.errors.funder_description ? true : false
                      }
                    />
                    {validation.touched.funder_description && validation.errors.funder_description ? (
                      <FormFeedback type="invalid">
                        {validation.errors.funder_description}
                      </FormFeedback>
                    ) : null}
                  </td>
                </tr>
                <tr>
                  <th scope="row">Хамгаалсан/нөхөн сэргээлт хийсэн байгууллага:</th>
                  <td className="fs-6">
                    <Input
                      name="company_description"
                      type="text"
                      validate={{
                        required: { value: true },
                      }}
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.company_description || ""}
                      invalid={
                        validation.touched.company_description && validation.errors.company_description ? true : false
                      }
                    />
                    {validation.touched.company_description && validation.errors.company_description ? (
                      <FormFeedback type="invalid">
                        {validation.errors.company_description}
                      </FormFeedback>
                    ) : null}
                  </td>
                </tr>
                <tr>
                  <th scope="row">Тайлбар</th>
                  <td className="fs-6">
                    <Input
                      name="description"
                      type="text"
                      validate={{
                        required: { value: true },
                      }}
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.description || ""}
                      invalid={
                        validation.touched.description && validation.errors.description ? true : false
                      }
                    />
                    {validation.touched.description && validation.errors.description ? (
                      <FormFeedback type="invalid">
                        {validation.errors.description}
                      </FormFeedback>
                    ) : null}
                  </td>
                </tr>
                <tr>
                  <th scope="row">Зарцуулсан хөрөнгийн хэмжээ, мян.төг</th>
                  <td>
                    <Input
                      name="total_cost"
                      type="text"
                      validate={{
                        required: { value: true },
                      }}
                      onChange={(e) => {
                        const rawValue = e.target.value.replace(/,/g, '');
                        validation.setFieldValue('total_cost', rawValue);
                      }}
                      onBlur={validation.handleBlur}
                      value={numberWithCommas(validation.values.total_cost) || ""}
                      invalid={
                        validation.touched.total_cost && validation.errors.total_cost ? true : false
                      }
                    />
                    {validation.touched.total_cost && validation.errors.total_cost ? (
                      <FormFeedback type="invalid">
                        {validation.errors.total_cost}
                      </FormFeedback>
                    ) : null}
                  </td>
                </tr>
                <tr>
                  <th scope="row">Хамгаалах арга хэмжээ авсан огноо</th>
                  <td>
                    <Flatpickr
                      className="form-control d-block"
                      placeholder="Огноо"
                      name="safeted_date"
                      value={validation.values.safeted_date}
                      onChange={(selectDate: Date[]) => {
                        if (selectDate[0]) {
                          const localDate = new Date(selectDate[0].getTime() - selectDate[0].getTimezoneOffset() * 60000)
                            .toISOString()
                            .split('T')[0];
                          validation.setFieldValue('safeted_date', localDate);
                        }
                      }}
                      options={{
                        altInput: true,
                        altFormat: "Y-m-d",
                        dateFormat: "Y-m-d",
                        enableTime: false,
                      }}
                    />

                    {validation.touched.safeted_date && validation.errors.safeted_date ? (
                      <FormFeedback type="invalid">
                        {validation.errors.safeted_date}
                      </FormFeedback>
                    ) : null}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="hstack gap-2">
            <button type="submit" className="btn btn-primary w-100" > Засварлах </button>
          </div>
        </Form>
      </Col>
    </>
  );


}

export default Create;